import {Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import { FaqPageDetailDto } from '../../../domain/faq/faqNodeDetailDto';
import { FaqMailSubjectPipe } from '../../../pipes/faq/faqMailSubject.pipe';
import {GhostComponent} from '../../../utils/ghostComponent';
import {ModalControllerService} from '../../../services/common/modalController.service';
import {IziviaUriOpenerService} from '../../../services/common/iziviaUriOpener.service';
import {IziviaMobileDeviceService} from '../../../services/common/iziviaMobileDevice.service';
import {LINKIFY_CLASS_NAME} from '../../../pipes/linkify.pipe';

@Component({
    selector: 'faq-page[faqPage]',
    templateUrl: './faqPage.component.html',
    styleUrls: ['./faqPage.component.scss'],
})
export class FaqPageComponent extends GhostComponent implements OnInit, OnDestroy {
    @Input() faqPage: FaqPageDetailDto;

    private clickEventListener?: () => void;

    constructor(private readonly modalControllerService: ModalControllerService,
        private readonly uriOpenerService: IziviaUriOpenerService,
        private readonly mobileDeviceService: IziviaMobileDeviceService,
        private readonly faqMailSubjectPipe: FaqMailSubjectPipe,
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef) {
        super();
    }

    ngOnInit(): void {
        if (this.mobileDeviceService.isMobileDevice()) {
            this.clickEventListener = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
                if (event.target instanceof HTMLAnchorElement && event.target.classList.contains(LINKIFY_CLASS_NAME)) {
                    this.handleAnchorClickInCordova(event);
                }
            });
        }
    }

    ngOnDestroy(): void {
        if (this.mobileDeviceService.isMobileDevice()) {
            // remove event listener
            this.clickEventListener();
        }
    }

    /**
     * Delegate opening of URLs to a specific service for cordova platform to overcome default behaviour
     * (i.e. opening links in the current webview with poor UX)
     *
     * @param event Click event
     */
    private handleAnchorClickInCordova(event: Event): void {
        // Prevent opening anchors the default way
        event.preventDefault();
        event.stopPropagation();

        const anchor = event.target as HTMLAnchorElement;
        this.uriOpenerService.open(anchor.href);
    };

    generateGhost(): void {
    }
}
